var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3",attrs:{"id":"staff-page"}},[_c('HeaderCards'),_c('ActiveInformations'),_c('DetailsCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }